export const POS_SYSTEM_OPTIONS = [
  'Treez',
  'Dutchie',
  'Flowhub',
  'COVA',
  'Blaze',
  'Unsupported POS',
] as const;

export type PosSystemOption = (typeof POS_SYSTEM_OPTIONS)[number];

export function isPosSystemOption(value: string | null | undefined): value is PosSystemOption {
  const normalized = value?.trim();
  return Boolean(normalized && POS_SYSTEM_OPTIONS.includes(normalized as PosSystemOption));
}

export function normalizePosSystemOption(value: string | null | undefined): PosSystemOption | '' {
  const normalized = value?.trim();

  if (!normalized) {
    return '';
  }

  return isPosSystemOption(normalized)
    ? normalized
    : 'Unsupported POS';
}
